/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getEquipment } from 'app/entities/equipment/equipment.reducer';
import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { createEntity, getEntity, reset, updateEntity } from './diaglab-equipment.reducer';

export const DiaglabEquipmentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const equipment = useAppSelector(state => state.equipment.entities);
  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const diaglabEquipmentEntity = useAppSelector(state => state.diaglabEquipment.entity);
  const loading = useAppSelector(state => state.diaglabEquipment.loading);
  const updating = useAppSelector(state => state.diaglabEquipment.updating);
  const updateSuccess = useAppSelector(state => state.diaglabEquipment.updateSuccess);

  const handleClose = () => {
    navigate(`/diaglab-equipment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getEquipment({}));
    dispatch(getDiagLabs({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.mfdDate !== undefined && typeof values.mfdDate !== 'number') {
      values.mfdDate = Number(values.mfdDate);
    }
    if (values.dateSupended !== undefined && typeof values.dateSupended !== 'number') {
      values.dateSupended = Number(values.dateSupended);
    }
    if (values.maintainanceCycle !== undefined && typeof values.maintainanceCycle !== 'number') {
      values.maintainanceCycle = Number(values.maintainanceCycle);
    }
    if (values.lastMaintenanceDate !== undefined && typeof values.lastMaintenanceDate !== 'number') {
      values.lastMaintenanceDate = Number(values.lastMaintenanceDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...diaglabEquipmentEntity,
      ...values,
      equipment: equipment.find(it => it.id.toString() === values.equipment?.toString()),
      diagLab: diagLabs.find(it => it.id.toString() === values.diagLab?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...diaglabEquipmentEntity,
          equipment: diaglabEquipmentEntity?.equipment?.id,
          diagLab: diaglabEquipmentEntity?.diagLab?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.diaglabEquipment.home.createOrEditLabel" data-cy="DiaglabEquipmentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.diaglabEquipment.home.createOrEditLabel">Create or edit a DiaglabEquipment</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="diaglab-equipment-id"
                  label={translate('tinyMedicRestApp.diaglabEquipment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.name')}
                id="diaglab-equipment-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.aeTitle')}
                id="diaglab-equipment-aeTitle"
                name="aeTitle"
                data-cy="aeTitle"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.supended')}
                id="diaglab-equipment-supended"
                name="supended"
                data-cy="supended"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.mfdDate')}
                id="diaglab-equipment-mfdDate"
                name="mfdDate"
                data-cy="mfdDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.dateSupended')}
                id="diaglab-equipment-dateSupended"
                name="dateSupended"
                data-cy="dateSupended"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.reasonSupended')}
                id="diaglab-equipment-reasonSupended"
                name="reasonSupended"
                data-cy="reasonSupended"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.maintainanceCycle')}
                id="diaglab-equipment-maintainanceCycle"
                name="maintainanceCycle"
                data-cy="maintainanceCycle"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.lastMaintenanceDate')}
                id="diaglab-equipment-lastMaintenanceDate"
                name="lastMaintenanceDate"
                data-cy="lastMaintenanceDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.active')}
                id="diaglab-equipment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.cursor')}
                id="diaglab-equipment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.lastUpdated')}
                id="diaglab-equipment-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.microSec')}
                id="diaglab-equipment-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.timestampEntry')}
                id="diaglab-equipment-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.mwl')}
                id="diaglab-equipment-mwl"
                name="mwl"
                data-cy="mwl"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabEquipment.underMaintainance')}
                id="diaglab-equipment-underMaintainance"
                name="underMaintainance"
                data-cy="underMaintainance"
                check
                type="checkbox"
              />
              <ValidatedField
                id="diaglab-equipment-equipment"
                name="equipment"
                data-cy="equipment"
                label={translate('tinyMedicRestApp.diaglabEquipment.equipment')}
                type="select"
                required
              >
                <option value="" key="0" />
                {equipment
                  ? equipment.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="diaglab-equipment-diagLab"
                name="diagLab"
                data-cy="diagLab"
                label={translate('tinyMedicRestApp.diaglabEquipment.diagLab')}
                type="select"
                required
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/diaglab-equipment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DiaglabEquipmentUpdate;
